import React, { useEffect, useState } from 'react';
import { ref, get, update, remove } from 'firebase/database';
import { database } from '../firebase/config';
import { pdf } from '@react-pdf/renderer';
import { formattaData } from '../utils/dateUtils';
import PreventivoPDF from '../pdf/PreventivoPDF';
import CreaPreventivoForm from './CreaPreventivoForm';

export default function ListaPreventivi({ onBack }) {
  const [preventivi, setPreventivi] = useState([]);
  const [clienti, setClienti] = useState({});
  const [cantieri, setCantieri] = useState({});
  const [loading, setLoading] = useState(true);
  const [pdfInApertura, setPdfInApertura] = useState(null);
  const [preventivoInModifica, setPreventivoInModifica] = useState(null);

  function handleModifica(preventivo) {
    setPreventivoInModifica(preventivo);
  }

  function handleChiudiModifica() {
    setPreventivoInModifica(null);
    caricaDati();
  }

async function caricaDati() {
  try {
    setLoading(true);
    const [preventiviSnap, clientiSnap, cantieriSnap] = await Promise.all([
      get(ref(database, 'preventivi')),
      get(ref(database, 'clienti')),
      get(ref(database, 'cantieri')),
    ]);
    if (clientiSnap.exists()) {
      setClienti(clientiSnap.val());
    }
    if (cantieriSnap.exists()) {
      setCantieri(cantieriSnap.val());
    }
    if (preventiviSnap.exists()) {
      const lista = Object.entries(preventiviSnap.val())
        .map(([id, valore]) => ({ id, ...valore }))
        .sort((a, b) => (b.dataPreventivo || '').localeCompare(a.dataPreventivo || ''));
      setPreventivi(lista);
    } else {
      setPreventivi([]);
    }
  } catch (errore) {
    console.error('Errore caricamento preventivi:', errore);
    alert('Errore nel caricamento dei preventivi: ' + errore.message);
  } finally {
    setLoading(false);
  }
}

useEffect(() => {
  caricaDati();
}, []);


function fmtCHF(numero) {
  const n = Number(numero) || 0;
  const negativo = n < 0;
  const numeroAbs = Math.abs(n).toFixed(2);
  const [parteIntera, parteDecimale] = numeroAbs.split('.');
  const parteInteraFormattata = parteIntera.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return (negativo ? '-' : '') + parteInteraFormattata + '.' + parteDecimale;
}

  async function toggleSpedito(id, attuale) {
    try {
      await update(ref(database, `preventivi/${id}`), {
        spedito: !attuale,
      });

      setPreventivi((precedenti) =>
        precedenti.map((preventivo) =>
          preventivo.id === id
            ? { ...preventivo, spedito: !attuale }
            : preventivo
        )
      );
    } catch (errore) {
      alert('Errore aggiornamento stato spedito: ' + errore.message);
    }
  }

  async function toggleAccettato(id, attuale) {
    const nuovoStatoAccettato = !attuale;

    try {
      const aggiornamenti = {
        accettato: nuovoStatoAccettato,
      };

      // Se accettato diventa false, resetta anche fatturato a false
      if (!nuovoStatoAccettato) {
        aggiornamenti.fatturato = false;
      }

      await update(ref(database, `preventivi/${id}`), aggiornamenti);

      setPreventivi((precedenti) =>
        precedenti.map((preventivo) =>
          preventivo.id === id
            ? {
                ...preventivo,
                accettato: nuovoStatoAccettato,
                fatturato: nuovoStatoAccettato ? preventivo.fatturato : false,
              }
            : preventivo
        )
      );
    } catch (errore) {
      alert('Errore aggiornamento stato accettato: ' + errore.message);
    }
  }


  async function toggleFatturato(id, preventivo) {
    // Permetti di fatturare solo se il preventivo è accettato
    if (!preventivo.accettato) {
      alert('Il preventivo deve essere accettato per poterlo segnare come fatturato.');
      return;
    }

    const nuovoStato = !preventivo.fatturato;

    try {
      await update(ref(database, `preventivi/${id}`), {
        fatturato: nuovoStato,
      });

      setPreventivi((precedenti) =>
        precedenti.map((p) =>
          p.id === id ? { ...p, fatturato: nuovoStato } : p
        )
      );
    } catch (errore) {
      alert('Errore aggiornamento stato fatturato: ' + errore.message);
    }
  }


  async function eliminaPreventivo(id, numero) {
    if (!window.confirm(`Eliminare definitivamente il preventivo ${numero || id}?`)) {
      return;
    }

    try {
      await remove(ref(database, `preventivi/${id}`));

      setPreventivi((precedenti) =>
        precedenti.filter((preventivo) => preventivo.id !== id)
      );
    } catch (errore) {
      alert('Errore eliminazione preventivo: ' + errore.message);
    }
  }


  async function apriPDF(preventivo) {
    let nuovaScheda = null;

    try {
      nuovaScheda = window.open('', '_blank');

      if (!nuovaScheda) {
        alert('Il browser ha bloccato la nuova scheda. Consenti i popup per questo sito e riprova.');
        return;
      }

      nuovaScheda.document.write(
        '<!doctype html><html><head><title>Generazione PDF...</title></head><body style="font-family:Arial;padding:30px">Generazione preventivo...</body></html>'
      );
      nuovaScheda.document.close();

      setPdfInApertura(preventivo.id);

      const cliente = clienti[preventivo.clienteId] || null;
      const cantiere = preventivo.cantiereId
        ? cantieri[preventivo.cantiereId] || null
        : null;

      const blob = await pdf(
        <PreventivoPDF
          preventivo={preventivo}
          cliente={cliente}
          cantiere={cantiere}
        />
      ).toBlob();

      const urlPDF = URL.createObjectURL(blob);
      nuovaScheda.location.href = urlPDF;

      window.setTimeout(() => URL.revokeObjectURL(urlPDF), 60000);
    } catch (errore) {
      console.error('Errore apertura PDF preventivo:', errore);

      if (nuovaScheda && !nuovaScheda.closed) {
        nuovaScheda.close();
      }

      alert('Errore nella generazione del PDF: ' + errore.message);
    } finally {
      setPdfInApertura(null);
    }
  }

  if (preventivoInModifica) {
    return (
      <CreaPreventivoForm
        preventivoDaModificare={preventivoInModifica}
        onBack={handleChiudiModifica}
      />
    );
  }

  return (
    <div className="lista-container lista-fatture-container">

<div className="fatturazione-header">
  <button
    type="button"
    className="btn-logout"
    onClick={onBack}
  >
    Torna indietro
  </button>
</div>

      <div className="lista-header">
        <h2>📋 Lista preventivi</h2>
      </div>

      {loading ? (
        <p className="loading-text">Caricamento preventivi...</p>
      ) : preventivi.length === 0 ? (
        <div className="empty-state">
          <p>Nessun preventivo presente.</p>
        </div>
      ) : (
        <>
          <div className="lista-fatture-table-wrapper">
            <table className="data-table desktop-only lista-fatture-table">
              <thead>
  <tr>
    <th>Numero preventivo</th>
    <th>Data</th>
    <th>Cliente</th>
    <th>Cantiere</th>
    <th>Totale CHF</th>
    <th>Spedito</th>
    <th>Accettato</th>
    <th>Fatturato</th>
    <th>PDF</th>
    <th>Modifica</th>
    <th>Elimina</th>
  </tr>
</thead>

              <tbody>
                {preventivi.map((preventivo) => {
                  const cliente = clienti[preventivo.clienteId];
                  const cantiere = preventivo.cantiereId
                    ? cantieri[preventivo.cantiereId]
                    : null;

                  return (
                    <tr key={preventivo.id}>
                      <td>
                        <strong>{preventivo.numeroPreventivo || '-'}</strong>
                      </td>
                      <td>{formattaData(preventivo.dataPreventivo)}</td>
                      <td>{cliente?.ragioneSociale || '-'}</td>
                      <td>{cantiere?.luogo || '-'}</td>
                      <td style={{ textAlign: 'right' }}>
                        CHF {fmtCHF(preventivo.totale)}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <button
                          className={
                            preventivo.spedito
                              ? 'btn-success small'
                              : 'btn-danger small'
                          }
                          onClick={() =>
                            toggleSpedito(
                              preventivo.id,
                              Boolean(preventivo.spedito)
                            )
                          }
                        >
                          {preventivo.spedito ? 'Sì' : 'No'}
                        </button>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <button
                          className={
                            preventivo.accettato
                              ? 'btn-success small'
                              : 'btn-danger small'
                          }
                          onClick={() =>
                            toggleAccettato(
                              preventivo.id,
                              Boolean(preventivo.accettato)
                            )
                          }
                        >
                          {preventivo.accettato ? 'Sì' : 'No'}
                        </button>
                      </td>

                      <td style={{ textAlign: 'center' }}>
                        <button
                          className={
                            preventivo.accettato
                              ? (preventivo.fatturato ? 'btn-success small' : 'btn-danger small')
                              : 'btn-danger small'
                          }
                          onClick={() =>
                            toggleFatturato(preventivo.id, preventivo)
                          }
                          disabled={!preventivo.accettato}
                          title={
                            preventivo.accettato
                              ? 'Segna come fatturato / non fatturato'
                              : 'Il preventivo deve essere accettato'
                          }
                          style={{
                            opacity: preventivo.accettato ? 1 : 0.5,
                            cursor: preventivo.accettato ? 'pointer' : 'not-allowed',
                          }}
                        >
                          {preventivo.accettato
                            ? (preventivo.fatturato ? 'Sì' : 'No')
                            : 'No'}
                        </button>
                      </td>
<td style={{ textAlign: 'center' }}>
  <button
    className="btn-edit"
    type="button"
    onClick={() => apriPDF(preventivo)}
    disabled={pdfInApertura === preventivo.id}
    title="Visualizza preventivo PDF"
    aria-label={`Visualizza PDF preventivo ${preventivo.numeroPreventivo}`}
  >
    <img src="icon-pdf.svg" alt="PDF" style={{ width: 30, display: 'block' }} />
  </button>
</td>
<td style={{ textAlign: 'center' }}>
  <button
    className="btn-secondary small"
    type="button"
    onClick={() => handleModifica(preventivo)}
    title="Modifica preventivo"
    aria-label={`Modifica preventivo ${preventivo.numeroPreventivo}`}
  >
    Modifica
  </button>
</td>
<td style={{ textAlign: 'center' }}>
  <button
    className="btn-delete"
    type="button"
    onClick={() => eliminaPreventivo(preventivo.id, preventivo.numeroPreventivo)}
    title="Elimina preventivo"
    aria-label={`Elimina preventivo ${preventivo.numeroPreventivo}`}
  >
    <img src="icon-delete.svg" alt="Elimina" style={{ width: 30, display: 'block' }} />
  </button>
</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="mobile-cards">
            {preventivi.map((preventivo) => {
              const cliente = clienti[preventivo.clienteId];
              const cantiere = preventivo.cantiereId
                ? cantieri[preventivo.cantiereId]
                : null;

              return (
                <div key={preventivo.id} className="mobile-card">
                  <div className="mobile-card-header">
                    Preventivo {preventivo.numeroPreventivo || '-'}
                  </div>

                  <div className="mobile-card-row">
                    <span className="mobile-card-label">Data:</span>
                    <span className="mobile-card-value">
                      {formattaData(preventivo.dataPreventivo)}
                    </span>
                  </div>

                  <div className="mobile-card-row">
                    <span className="mobile-card-label">Cliente:</span>
                    <span className="mobile-card-value">
                      {cliente?.ragioneSociale || '-'}
                    </span>
                  </div>

                  <div className="mobile-card-row">
                    <span className="mobile-card-label">Cantiere:</span>
                    <span className="mobile-card-value">
                      {cantiere?.luogo || '-'}
                    </span>
                  </div>

                  <div className="mobile-card-row">
                    <span className="mobile-card-label">Totale:</span>
                    <span className="mobile-card-value">
                      <strong>CHF {fmtCHF(preventivo.totale)}</strong>
                    </span>
                  </div>

                  <div className="mobile-card-row">
                    <span className="mobile-card-label">Spedito:</span>
                    <span className="mobile-card-value">
                      <button
                        className={
                          preventivo.spedito
                            ? 'btn-success small'
                            : 'btn-danger small'
                        }
                        onClick={() =>
                          toggleSpedito(
                            preventivo.id,
                            Boolean(preventivo.spedito)
                          )
                        }
                      >
                        {preventivo.spedito ? 'Sì' : 'No'}
                      </button>
                    </span>
                  </div>

                  <div className="mobile-card-row">
                    <span className="mobile-card-label">Accettato:</span>
                    <span className="mobile-card-value">
                      <button
                        className={
                          preventivo.accettato
                            ? 'btn-success small'
                            : 'btn-danger small'
                        }
                        onClick={() =>
                          toggleAccettato(
                            preventivo.id,
                            Boolean(preventivo.accettato)
                          )
                        }
                      >
                        {preventivo.accettato ? 'Sì' : 'No'}
                      </button>
                    </span>
                  </div>

                  <div className="mobile-card-row">
                    <span className="mobile-card-label">Fatturato:</span>
                    <span className="mobile-card-value">
                      <button
                        className={
                          preventivo.accettato
                            ? (preventivo.fatturato ? 'btn-success small' : 'btn-danger small')
                            : 'btn-danger small'
                        }
                        onClick={() =>
                          toggleFatturato(preventivo.id, preventivo)
                        }
                        disabled={!preventivo.accettato}
                        title={
                          preventivo.accettato
                            ? 'Segna come fatturato / non fatturato'
                            : 'Il preventivo deve essere accettato'
                        }
                        style={{
                          opacity: preventivo.accettato ? 1 : 0.5,
                          cursor: preventivo.accettato ? 'pointer' : 'not-allowed',
                        }}
                      >
                        {preventivo.accettato
                          ? (preventivo.fatturato ? 'Sì' : 'No')
                          : 'No'}
                      </button>
                    </span>
                  </div>

<div className="mobile-card-row">
  <span className="mobile-card-label">PDF</span>
  <span className="mobile-card-value">
    <button
      className="btn-edit"
      type="button"
      onClick={() => apriPDF(preventivo)}
      disabled={pdfInApertura === preventivo.id}
      title="Visualizza preventivo PDF"
    >
      <img src="icon-pdf.svg" alt="PDF" style={{ width: 30, display: 'block' }} />
    </button>
  </span>
</div>
<div className="mobile-card-row">
  <span className="mobile-card-label">Modifica</span>
  <span className="mobile-card-value">
    <button
      className="btn-secondary small"
      type="button"
      onClick={() => handleModifica(preventivo)}
      title="Modifica preventivo"
    >
      Modifica
    </button>
  </span>
</div>
<div className="mobile-card-row">
  <span className="mobile-card-label">Elimina</span>
  <span className="mobile-card-value">
    <button
      className="btn-delete"
      type="button"
      onClick={() => eliminaPreventivo(preventivo.id, preventivo.numeroPreventivo)}
      title="Elimina preventivo"
    >
      <img src="icon-delete.svg" alt="Elimina" style={{ width: 30, display: 'block' }} />
    </button>
  </span>
</div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}